module.exports = __webpack_public_path__ + "assets/img/userAvatar.f9fcc796.png";